import React, { useRef, useEffect, useState } from "react";
import "./ImageProcessor.css";

const ImageProcessor = ({ imageSrc, rows = 100 }) => {
  const [binaryData, setBinaryData] = useState([]);
  const canvasRef = useRef(null);

  useEffect(() => {
    if (imageSrc) processImage();
  }, [imageSrc]);

  const processImage = () => {
    const img = new Image();
    img.src = imageSrc;
    img.onload = () => {
      const canvas = canvasRef.current;
      const ctx = canvas.getContext("2d");

      const scale = Math.min(rows / img.width, rows / img.height);
      const width = Math.round(img.width * scale);
      const height = Math.round(img.height * scale);

      canvas.width = width;
      canvas.height = height;
      ctx.drawImage(img, 0, 0, width, height);

      const imageData = ctx.getImageData(0, 0, width, height);
      const data = imageData.data;

      for (let i = 0; i < data.length; i += 4) {
        const gray =
          0.299 * data[i] + 0.587 * data[i + 1] + 0.114 * data[i + 2];
        const threshold = gray > 128 ? 255 : 0;
        data[i] = data[i + 1] = data[i + 2] = threshold;
      }

      ctx.putImageData(imageData, 0, 0);

      const binaryArray = [];
      for (let y = 0; y < height; y++) {
        const row = [];
        for (let x = 0; x < width; x++) {
          const index = (y * width + x) * 4;
          row.push(data[index] === 255 ? 1 : 0);
        }
        binaryArray.push(row);
      }
      setBinaryData(binaryArray);
    };
  };

  return (
    <div>
      <canvas ref={canvasRef} style={{ display: "none", margin: "0 auto" }} />
      {binaryData.length > 0 &&
        binaryData.map((bin, index) => (
          <div key={index} className="row">
            {bin.map((b, i) => (
              <input
                key={`${index}-${i}`}
                name={`${index}-${i}`}
                type="checkbox"
                checked={b === 0}
                readOnly
              />
            ))}
          </div>
        ))}
    </div>
  );
};

export default ImageProcessor;
